// extracted by mini-css-extract-plugin
module.exports = {"fillSpacer":"FillSpacer_fillSpacer__N7_7R"};